module.exports = __webpack_public_path__ + "img/image6.f528a244.png";